import clientesApi from '../services/clientesApi';

export async function getNumeroPassaporteCliente(processo: any): Promise<string> {
    let numero = processo?.cliente?.numero_passaporte || '';
    if (!numero && processo?.cliente?.id) {
        const { data, isError } = await clientesApi.one(String(processo.cliente.id));
        if (!isError) {
            numero = data?.data?.numero_passaporte || '';
        }
    }
    return numero;
}
